import styled from 'styled-components';

const IndexCss = styled.div`
width:100%;
padding:10px;
`;

export default IndexCss;